import React from "react";
import html2canvas from "html2canvas";
import { Box } from "@mui/material";
import PrintPurchaseOrder from "../../assets/Images/CommonImages/Print.png";
import { useReactToPrint } from "react-to-print";


const PagePrint = ({ pageref}) => {
  const handlePrint = useReactToPrint({
    isPrintOn: true,
    content: () => pageref.current,
  });


  return <Box
    component="img"
    src={PrintPurchaseOrder}
    sx={{ width: "22px", height: "auto", cursor: "pointer" }}
    onClick={handlePrint}
  />;
};

export default PagePrint;
